import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead } from "@/lib/seo";
import { BlogWatKostPage } from "@/pages/blog-wat-kost-een-website-laten-maken";

export const Route = createFileRoute("/$lang/blog/prix-site-web")({
  head: ({ params }) => {
    const lang = (params.lang as "fr" | "en") ?? "fr";
    const t = i18n.getFixedT(lang, "seo");
    return pageHead({
      lang,
      pathWithoutLang: "/blog/wat-kost-een-website-laten-maken",
      title: t("blog-wat-kost.title"),
      description: t("blog-wat-kost.description"),
    });
  },
  component: BlogWatKostPage,
});
